import { cn } from "@/lib/cn";

export function Section({ title, children, className }: { title: string; children: React.ReactNode; className?: string }) {
  return (
    <section className={cn("space-y-2", className)}>
      <h4 className="text-[10px] font-bold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">{title}</h4>
      <div className="space-y-2">{children}</div>
    </section>
  );
}

export function Field({ label, children, className, disabled }: { label: string; children: React.ReactNode; className?: string; disabled?: boolean }) {
  return (
    <label
      className={cn(
        "block rounded-lg border border-zinc-200 px-3 py-2 transition-colors dark:border-border",
        disabled ? "bg-zinc-50 dark:bg-muted/30" : "focus-within:border-brand-500 focus-within:ring-1 focus-within:ring-brand-500",
        className,
      )}
    >
      <span className="mb-0.5 block text-[10px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export function Input({
  value,
  onChange,
  ...rest
}: {
  value: string;
  onChange: (v: string) => void;
  type?: string;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}) {
  // Campo travado e vazio mostra traço, não placeholder: placeholder num campo que não aceita
  // digitação parece campo em branco esperando preenchimento, quando a leitura certa é "o parceiro
  // não preencheu isso no perfil dele".
  return (
    <input
      {...rest}
      value={value}
      placeholder={rest.disabled ? (value ? undefined : "—") : rest.placeholder}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        "w-full bg-transparent text-sm outline-none placeholder:text-zinc-400 dark:placeholder:text-muted-foreground",
        rest.disabled ? "cursor-not-allowed text-zinc-500 dark:text-muted-foreground" : "text-zinc-900 dark:text-foreground",
      )}
    />
  );
}

const UFS = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];

export function UfSelect({ value, onChange, disabled }: { value: string; onChange: (v: string) => void; disabled?: boolean }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={cn(
        "w-full bg-transparent text-sm outline-none",
        disabled ? "cursor-not-allowed text-zinc-500 dark:text-muted-foreground" : "cursor-pointer text-zinc-900 dark:text-foreground",
      )}
    >
      <option value="" className="bg-white dark:bg-popover">
        —
      </option>
      {UFS.map((u) => (
        <option key={u} value={u} className="bg-white dark:bg-popover">
          {u}
        </option>
      ))}
    </select>
  );
}
